export const getModalWrapper = ({ uid }) => `
<div class="${uid}_modal-overlay ${uid}_modal-container" id="${uid}_modal-overlay"/>
<div class="${uid}_modal" id="${uid}_modal">
    <div class="${uid}_modal-content">
        <div class="${uid}_container"/>
    </div>
</div>
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9tb2RhbC9odG1sL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyxDQUFDLEVBQUUsR0FBRyxFQUFtQixFQUFFLEVBQUUsQ0FBQztjQUMvQyxHQUFHLGtCQUFrQixHQUFHLHlCQUF5QixHQUFHO2NBQ3BELEdBQUcsZUFBZSxHQUFHO2tCQUNqQixHQUFHO3NCQUNDLEdBQUc7OztDQUd4QixDQUFDIn0=